// @ts-check
const KEY = 'qp-move.campaign.v1';
/** Local-only adapter. A previous valid record survives interrupted or malformed saves.
 * @param {(raw:unknown)=>import('../game/progress.js').Progress|null} validate @param {(message:string)=>void} notice
 */
export function createProgressStore(validate, notice) {
  /** @param {string|null} text */
  function decode(text) { try { return text ? validate(JSON.parse(text)) : null; } catch { return null; } }
  return {
    load() {
      try {
        const raw = window.localStorage.getItem(KEY), current = decode(raw);
        if (current) return current;
        const previous = decode(window.localStorage.getItem(`${KEY}.previous`));
        if (raw) notice(previous ? 'Recovered your previous save.' : 'The save could not be read. A fresh run is ready.');
        return previous;
      } catch { notice('Saving is unavailable in this browser. You can still play.'); return null; }
    },
    /** @param {import('../game/progress.js').Progress} progress */
    save(progress) {
      const valid = validate(progress);
      if (!valid) return false;
      try {
        const old = window.localStorage.getItem(KEY);
        if (decode(old)) window.localStorage.setItem(`${KEY}.previous`, /** @type {string} */ (old));
        window.localStorage.setItem(KEY, JSON.stringify(valid));
        return true;
      } catch { notice('Progress could not be saved. Keep this tab open to continue.'); return false; }
    },
  };
}
